export const iOSPWABottomPadding = 35;
export const iOSPWABottomBarHeight = 56;
